import { useLang } from '@/lib/i18n';
import { Button } from '@/components/ui/button';

export function LangToggle() {
  const { lang, setLang } = useLang();

  return (
    <Button
      variant="ghost"
      size="sm"
      onClick={() => setLang(lang === 'fr' ? 'en' : 'fr')}
      className="h-9 px-2.5 text-xs font-semibold tracking-widest text-muted-foreground hover:text-foreground transition-colors"
      aria-label="Switch language"
    >
      {lang === 'fr' ? 'EN' : 'FR'}
    </Button>
  );
}
